import React, { useState } from 'react';

const steps = [
  {
    number: '01',
    title: 'Planning',
    icon: '/pictures/property_1_b80f359b9e.svg',
    description: 'We start by thoroughly understanding your business goals, requirements, and constraints to create a solid project roadmap.',
  },
  {
    number: '02',
    title: 'Tech architecture',
    icon: '/pictures/property_2_d246da1c4b.svg',
    description: 'Our team designs a robust, scalable technical architecture tailored to your specific project needs and future growth.',
  },
  {
    number: '03',
    title: 'Daily meeting',
    icon: '/pictures/property_3_df7cb525ec.svg',
    description: 'Using Agile methodology with daily standups ensures transparency, rapid iteration, and continuous alignment with your vision.',
  },
  {
    number: '04',
    title: 'Reviews',
    icon: '/pictures/property_4_2b7e6613cd.svg',
    description: 'Regular sprint reviews and demo sessions keep you in the loop and allow us to incorporate feedback at every stage.',
  },
];

export default function DevelopmentProcess() {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section style={{ padding: '100px 24px', background: 'white' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '72px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '16px' }}>
            <div style={{ width: '24px', height: '3px', backgroundColor: '#0099CC', borderRadius: '2px' }}></div>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#0099CC', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Process
            </span>
            <div style={{ width: '24px', height: '3px', backgroundColor: '#0099CC', borderRadius: '2px' }}></div>
          </div>
          <h2 style={{ fontSize: 'clamp(28px, 3vw, 40px)', fontWeight: '700', color: '#111827', marginBottom: '12px', letterSpacing: '-0.5px' }}>
            Our Development Process
          </h2>
          <p style={{ fontSize: '17px', color: '#6B7280', maxWidth: '480px', margin: '0 auto', lineHeight: 1.7 }}>
            How we stand up and develop using Agile
          </p>
        </div>

        {/* Steps grid */}
        <div className="process-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px', position: 'relative' }}>
          {/* Connector line */}
          <div className="connector-line" style={{
            position: 'absolute',
            top: '60px',
            left: '12.5%',
            right: '12.5%',
            height: '2px',
            background: 'linear-gradient(to right, #0099CC, #E5E7EB)',
            zIndex: 0,
          }} />

          {steps.map((step, idx) => (
            <div
              key={idx}
              className="process-step"
              onClick={() => setActiveStep(idx)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                position: 'relative',
                zIndex: 1,
                padding: '24px 16px',
                borderRadius: '16px',
                transition: 'background-color 0.2s ease',
                backgroundColor: activeStep === idx ? '#F0F9FF' : 'transparent',
              }}
            >
              {/* Number badge */}
              <div style={{
                width: '48px', height: '48px',
                borderRadius: '50%',
                backgroundColor: activeStep === idx ? '#0099CC' : '#F3F4F6',
                border: activeStep === idx ? '3px solid #0099CC' : '3px solid #E5E7EB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                transition: 'background-color 0.2s ease, border-color 0.2s ease',
              }}>
                <span style={{ fontSize: '14px', fontWeight: '700', color: activeStep === idx ? 'white' : '#374151' }}>
                  {step.number}
                </span>
              </div>

              {/* Icon */}
              <div style={{
                width: '100px',
                height: '100px',
                marginBottom: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <img
                  src={step.icon}
                  alt={step.title}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  onError={e => { e.target.style.display = 'none'; }}
                />
              </div>

              <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>
                {step.title}
              </h3>
              <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.7 }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .process-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 480px) {
          .process-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
